import { groupCookies } from '@yarmill/const';
import { GroupStore } from '@yarmill/types';

export function persistSelectedGroup(group: GroupStore): void {
  window.localStorage.setItem(groupCookies.GROUP, String(group.id));
}
